import type { MetaFunction } from 'react-router'
import { STATIC_PAGE_HEADERS } from "~/lib/cache.server"
import { Navbar } from '~/components/navbar'
import { Footer } from '~/components/footer'

export function headers() { return STATIC_PAGE_HEADERS }

export const meta: MetaFunction = () => [
  { title: 'Conditions générales — AfficheServices' },
  { name: 'description', content: 'Conditions générales de vente et d\'utilisation de la plateforme AfficheServices.' },
  { tagName: 'link', rel: 'canonical', href: 'https://www.afficheservices.fr/cgv' },
]

export default function CGV() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="mx-auto max-w-3xl px-4 py-16 lg:px-6">
        <h1 className="text-3xl font-bold text-slate-900">Conditions générales</h1>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed">
          Dernière mise à jour : Mars 2026
        </p>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed">
          Les présentes conditions générales de vente et d'utilisation (ci-après « CGV ») régissent
          l'utilisation de la plateforme AfficheServices accessible à l'adresse afficheservices.fr.
          En utilisant la plateforme, vous acceptez sans réserve l'intégralité des présentes CGV.
        </p>

        {/* Article 1 - Objet */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Article 1 — Objet</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Les présentes CGV ont pour objet de définir les conditions dans lesquelles
            AfficheServices SAS (ci-après « AfficheServices ») met à disposition des utilisateurs
            sa plateforme de mise en relation entre particuliers et professionnels du bâtiment.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            AfficheServices agit en qualité d'intermédiaire technique et ne réalise aucune
            prestation de travaux. La plateforme permet aux particuliers de décrire leurs projets
            et de recevoir des devis de professionnels inscrits.
          </p>
        </div>

        {/* Article 2 - Inscription */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Article 2 — Inscription</h2>
          <h3 className="mt-6 text-lg font-medium text-slate-900 mb-2">2.1 Particuliers</h3>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            L'inscription sur la plateforme est gratuite pour les particuliers. L'utilisateur
            s'engage à fournir des informations exactes et à jour lors de son inscription. Tout
            utilisateur doit être âgé d'au moins 18 ans et avoir la capacité juridique de contracter.
          </p>
          <h3 className="mt-6 text-lg font-medium text-slate-900 mb-2">2.2 Professionnels</h3>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            L'inscription des professionnels est soumise à la vérification de leurs qualifications,
            assurances professionnelles et numéro SIRET. AfficheServices se réserve le droit de
            refuser ou de suspendre toute inscription ne répondant pas à ses critères de qualité.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Le professionnel s'engage à maintenir à jour ses documents administratifs (attestation
            d'assurance, Kbis, qualifications) et à informer AfficheServices de tout changement
            dans sa situation.
          </p>
        </div>

        {/* Article 3 - Services proposés */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Article 3 — Services proposés</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            AfficheServices propose les services suivants :
          </p>
          <ul className="mt-3 space-y-2 text-sm text-slate-600 leading-relaxed list-disc pl-5">
            <li>
              Mise en relation entre particuliers et professionnels du bâtiment pour des projets de
              travaux (plomberie, électricité, peinture, rénovation, menuiserie, toiture, etc.)
            </li>
            <li>
              Réception de devis personnalisés de la part de professionnels vérifiés
            </li>
            <li>
              Consultation des profils et avis clients des professionnels inscrits
            </li>
            <li>
              Accompagnement et suivi des demandes de devis
            </li>
          </ul>
        </div>

        {/* Article 4 - Tarification */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Article 4 — Tarification</h2>
          <h3 className="mt-6 text-lg font-medium text-slate-900 mb-2">4.1 Pour les particuliers</h3>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            L'utilisation de la plateforme est entierement gratuite pour les particuliers.
            La demande de devis, la consultation des profils et la mise en relation avec les
            professionnels ne font l'objet d'aucune facturation.
          </p>
          <h3 className="mt-6 text-lg font-medium text-slate-900 mb-2">4.2 Pour les professionnels</h3>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Les professionnels accedent aux demandes de devis via un systeme de credits. Le tarif
            des credits varie selon la categorie de service et la localisation du projet. Les
            conditions tarifaires detaillees sont communiquees au professionnel lors de son
            inscription et sont disponibles dans son espace professionnel.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Les prix sont indiques en euros hors taxes (HT) et toutes taxes comprises (TTC). La TVA
            applicable est celle en vigueur au jour de la facturation.
          </p>
        </div>

        {/* Article 5 - Responsabilités */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Article 5 — Responsabilités</h2>
          <h3 className="mt-6 text-lg font-medium text-slate-900 mb-2">5.1 Responsabilité d'AfficheServices</h3>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            AfficheServices agit en tant qu'intermédiaire de mise en relation. A ce titre, elle ne
            saurait être tenue responsable de la qualité, de la conformité ou du prix des
            prestations réalisées par les professionnels. AfficheServices ne garantit pas la
            conclusion d'un contrat entre le particulier et le professionnel.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            AfficheServices met en œuvre tous les moyens raisonnables pour assurer la disponibilité
            et le bon fonctionnement de la plateforme, mais ne garantit pas un accès ininterrompu
            ou exempt d'erreurs.
          </p>
          <h3 className="mt-6 text-lg font-medium text-slate-900 mb-2">5.2 Responsabilité des utilisateurs</h3>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Les utilisateurs sont seuls responsables de l'utilisation qu'ils font de la plateforme.
            Ils s'engagent à ne pas utiliser la plateforme à des fins illicites ou contraires aux
            présentes CGV. Les professionnels sont responsables des informations qu'ils publient
            et des prestations qu'ils réalisent.
          </p>
        </div>

        {/* Article 6 - Données personnelles */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Article 6 — Données personnelles</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            AfficheServices collecte et traite les données personnelles de ses utilisateurs
            conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
            Informatique et Libertés du 6 janvier 1978 modifiée.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Pour en savoir plus sur le traitement de vos données personnelles, veuillez consulter
            notre{' '}
            <a href="/confidentialité" className="text-primary hover:underline">
              Politique de confidentialité
            </a>
            .
          </p>
        </div>

        {/* Article 7 - Modification des CGV */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Article 7 — Modification des CGV</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            AfficheServices se réserve le droit de modifier les présentes CGV à tout moment. Les
            modifications entrent en vigueur dès leur publication sur la plateforme. Les utilisateurs
            seront informés de toute modification substantielle par email ou notification sur la
            plateforme.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            L'utilisation continue de la plateforme après la publication des modifications vaut
            acceptation des nouvelles CGV. En cas de désaccord avec les modifications, l'utilisateur
            peut cesser d'utiliser la plateforme et demander la suppression de son compte.
          </p>
        </div>

        {/* Article 8 - Droit applicable */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">Article 8 — Droit applicable</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Les présentes CGV sont régies par le droit français. En cas de litige relatif à
            l'interprétation ou à l'exécution des présentes CGV, les parties s'engagent à rechercher
            une solution amiable avant toute action judiciaire.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Conformément aux dispositions du Code de la consommation, le consommateur est informe
            qu'il peut recourir à un médiateur de la consommation dans les conditions prévues aux
            articles L.611-1 et suivants du Code de la consommation. À défaut de résolution amiable,
            tout litige sera soumis aux tribunaux compétents de Paris.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  )
}
